/* sb-dc-tplfix.js — a template opened by ?tpl= must be built on the board it will
   actually be printed on.

   The bug: the augment bundle's applyTplFromUrl() builds the template against
   whatever board happens to be open, which at that moment is always the start
   popup's default (Custom Vinyl Banner, 8' x 4'). It never reads ?product=.
   When the customer then picks the real size, the spec-change refit scales x and
   y independently (8x4 -> 8x8 gives sx=1, sy=2), so every layer keeps its width
   and doubles its height: circles become tall ovals, icons squeeze.

   What this does, all client side:
     1. Works out the board the customer is actually heading for - from
        ?product= when the handle is one we sell (its own default size), and
        from the template's own proportions when it is not.
     2. Selects that product in the start popup, so the size and finishing shown
        there are the product's, not Custom Vinyl Banner's. We do NOT press
        Start - picking the size stays the customer's.
     3. Nudges the empty canvas onto that board early, so the bundle's own build
        already lands on the right shape.
     4. Sets the board ONCE more after the popup closes and then builds the
        template against whatever board is current.

   Step 3 is a nudge and not a requirement on purpose. Fixed-size inch products
   (x-banner, retractable) refuse an inch spec until their product is selected,
   so the setSpec is capped at a few tries and we fall through to step 4 rather
   than spinning.

   2026-08-31, two changes:

   The no-?product= board now comes from the template's OWN pixel dimensions
   instead of three fixed buckets. The buckets put every "wide" template on a
   10x8 board, so patriotic-2025-10x3 (a 1636x491 artwork, 10ft x 3ft) was laid
   on a board nearly three times too tall: the art kept its shape, filled the
   width and left a deep empty band above and below, which reads as "the
   elements do not stretch enough". A 10x3 artwork now gets a 10x3 board.
   boardForFit() is still the fallback for rows with no stored size.

   And step 4 re-applies the board before it builds. The step 3 nudge does
   land, but pressing Start in the popup resets the spec to the vinyl default,
   so by build time the board was 8x4 again and the artwork was rebuilt to the
   wrong shape - the same symptom, from the other end.

   2026-09-02, from a screenshot of a square template opened from the template
   page onto Custom Vinyl Banners, three changes:

   (a) "The first few size changes do nothing." Step 4 used to put the board
       back up to EIGHT times while it waited for the template list, and a
       customer who picked a size in that window was overruled every time. It
       now sets the board once; after that the size on screen is the
       customer's and is the board the template is fitted to.

   (b) "It opens as a square in the middle with the background either side."
       The template was laid on 8x4 with a contain fit, so a square artwork sat
       in the middle third. Now, when the artwork's own shape is known
       (dc_templates width_px/height_px) and the product is one sb-dc-refit.js
       covers, the template is built on ITS OWN board first and then handed to
       __dcRefit to fit the real one - the same rules as a size change, so
       opening a template and resizing to that size give the same picture:
       backdrop image covers, text and panels fit inside.

   (c) Step 4 never ran for that square template at all. __dcTemplateList is
       filtered by the CURRENT board's shape, and on 8x4 a square template is
       not in it, so the loop waited for a template that was never coming while
       the bundle's own applyTplFromUrl() had already drawn it (contain, on
       8x4). So there is now a second route: when the template is not in the
       list but layers have appeared and hold still, and their combined box has
       the artwork's proportions, that box IS the template as built - treat it
       as the artwork board and refit it to the real one, exactly as (b) does
       for a fresh build. Either route ends with the same picture.

   2026-09-08 (V0.1.0) — 스티커처럼 «정해진 크기 목록» 이 있는 인치 상품은, 판을
   카탈로그 기본값(오벌 5x3) 이 아니라 «템플릿 자체 크기» 로 연다.
   오벌 템플릿 75장은 전부 6x4(982x655px) 인데 판이 5x3 으로 열려서, 타원이
   재단선에 못 미치고 양옆에 흰 초승달이 남았다(헤드리스 크롬 실측 0.25in).
   boardForEntry() 가 presetsIn 안에서 고른다 — 이름의 «6x4» 가 목록에 있으면
   그것, 없으면 그림 비율에 가장 가까운 크기, 동률이면 카탈로그 기본값. 결과는
   언제나 그 상품이 파는 크기 중 하나다. 그래서 1단계는 이 상품들에 한해 행
   (fitRow) 이 올 때까지 기다린다 — 세 번 실패하면 {} 로 와서 예전 기본값.

   Lives in its own asset because sb-dc-aug.js is far past the size the theme
   API will take in one write. */
(function () {
  "use strict";

  var qs = location.search;
  var m = /[?&]tpl=([^&]+)/.exec(qs);
  if (!m) return;

  var TPL_ID = "r_" + decodeURIComponent(m[1]);
  var pm = /[?&]product=([^&]+)/.exec(qs);
  var HANDLE = pm ? decodeURIComponent(pm[1]) : "";

  var SB = "https://uktrkymhgmzlufzxsavf.supabase.co";
  var KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVrdHJreW1oZ216bHVmenhzYXZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc4Nzg0MjAsImV4cCI6MjEwMzQ1NDQyMH0.BBMLGRs0BkBhb45ZkY5MddnslJT355lQyBZvjMe7ndY";

  var state = {
    board: null, why: "", tries: 0, nudged: false, finalSet: false,
    picked: false, popupSeen: false, applied: false, at: null, art: null,
    stable: 0, route: ""
  };
  window.__dcTplFixDebug = function () { return JSON.parse(JSON.stringify(state)); };

  /* ---- where the board comes from ------------------------------------- */

  // Last resort only: the row carries no pixel size. Same three buckets the
  // template page files templates under.
  function boardForFit(fit) {
    fit = fit || [];
    if (fit.indexOf("square") > -1) return { w: 96, h: 96 };   //  8 x 8 ft
    if (fit.indexOf("tall") > -1) return { w: 96, h: 120 };    //  8 x 10 ft
    return { w: 120, h: 96 };                                  // 10 x 8 ft
  }

  /* The artwork's own proportions, snapped to whole feet. A 1636x491 file is
     10ft x 3ft, which is what its name says and what it was drawn for.
     Banners are sold in whole feet, 2 to 50, with one side 8ft or less, so the
     result is clamped into that shape rather than handed over raw. */
  function boardFromRow(row) {
    if (!row) return null;
    var pw = +row.width_px, ph = +row.height_px;
    if (!(pw > 0 && ph > 0)) return null;
    var r = pw / ph;
    var wFt, hFt;
    if (r >= 1) { wFt = 10; hFt = Math.round(10 / r); }
    else { hFt = 10; wFt = Math.round(10 * r); }

    wFt = Math.min(50, Math.max(2, wFt));
    hFt = Math.min(50, Math.max(2, hFt));

    // One side has to be 8ft or under. Shrink the pair, keeping the shape.
    if (wFt > 8 && hFt > 8) {
      var k = 8 / Math.min(wFt, hFt);
      wFt = Math.max(2, Math.round(wFt * k));
      hFt = Math.max(2, Math.round(hFt * k));
    }
    return { w: wFt * 12, h: hFt * 12 };
  }

  function catalogEntry(handle) {
    var cat = window.__CAT;
    if (!cat || !handle) return null;
    for (var i = 0; i < cat.length; i++) {
      var items = (cat[i] && cat[i].items) || [];
      for (var j = 0; j < items.length; j++) {
        if (items[j] && items[j].handle === handle) return { item: items[j], cat: i };
      }
    }
    return null;
  }

  function hasPresets(e) {
    return !!(e && e.item.unit === "in" && e.item.presetsIn && e.item.presetsIn.length);
  }

  /* 크기 목록이 있는 인치 상품(스티커·X배너 등): 템플릿이 그려진 크기로 연다.
     row 가 없으면(조회 실패·크기 미기록) 카탈로그 기본값. */
  function boardForEntry(e, row) {
    var p = e.item, k = p.unit === "in" ? 1 : 12;
    if (!p.w || !p.h) return null;
    var dflt = { w: p.w * k, h: p.h * k };
    if (!hasPresets(e) || !row) return dflt;

    var presets = p.presetsIn.map(function (s) {
      var d = s.split("x");
      return { w: +d[0], h: +d[1] };
    }).filter(function (q) { return q.w > 0 && q.h > 0; });
    if (!presets.length) return dflt;

    /* 2026-09-18 (B안): 새 배치 엔진이 아는 크기가 하나라도 있으면 그 중에서만 고른다.
       엔진 밖 상품(스티커·X배너 등)은 걸러지는 게 없어 예전 그대로. */
    var ok914 = presets.filter(function (q) {
      try { return window.SBDC914.supports({ product: p.handle || HANDLE, widthIn: q.w, heightIn: q.h }); }
      catch (e2) { return false; }
    });
    if (ok914.length) presets = ok914;

    // 이름에 적힌 크기(oval-soccer-6x4)가 파는 크기면 그것
    var m = /(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/i.exec(String(row.name || ""));
    if (m) {
      for (var i = 0; i < presets.length; i++) {
        if (presets[i].w === +m[1] && presets[i].h === +m[2]) return presets[i];
      }
    }
    // 아니면 그림 비율에 가장 가까운 크기 — 동률이면 기본값(원형 2x2~5x5 는 전부 동률)
    var pw = +row.width_px, ph = +row.height_px;
    if (!(pw > 0 && ph > 0)) return dflt;
    var r = pw / ph, best = null, bestD = Infinity;
    for (var j = 0; j < presets.length; j++) {
      var d2 = Math.abs(presets[j].w / presets[j].h - r);
      var tie = Math.abs(d2 - bestD) < 1e-9;
      if (d2 < bestD - 1e-9 || (tie && presets[j].w === dflt.w && presets[j].h === dflt.h)) {
        best = presets[j]; bestD = d2;
      }
    }
    return best || dflt;
  }

  // The row's size and fit. Always asked for now: (b) and (c) need the
  // artwork's own shape even when ?product= decides the board.
  /* 2026-09-05 — 실패를 «없음» 으로 바꿔치기하던 것을 고쳤다.

     전에는 r.ok 를 안 보고 바로 r.json() 을 했다. PostgREST 는 오류도 «올바른
     JSON» 으로 준다 — 400 이면 {"code":"22P02","message":"invalid input syntax
     for type uuid"} 가 온다. 그래서 파싱이 «성공» 하고, 배열이 아니므로
     rows[0] 이 undefined 가 되어 fitRow 가 {} 로 확정됐다. 즉 «서버가 400 을
     줬다» 가 «데이터가 없다» 로 둔갑했고, 화면에도 콘솔에도 아무것도 안 떴다.
     (?tpl= 에 형식이 틀린 값을 넣어 실제로 400 을 받아 확인함.)

     그 결과: ?product= 이 없거나 그 상품이 __CAT 에 없으면 boardFromRow({}) 가
     null → boardForFit(undefined) 로 흘러 판이 무조건 10ft x 8ft 로 잡혔다.

     ⚠ 실패 시 fitRow 를 null 로 «남겨 두면 안 된다». 359행의
        `if (!fitRow) return;` 은 ?product= 가 있는 정상 동선에서도 도는
        관문이라, null 로 두면 템플릿이 아무에게도 안 그려진다.
        그래서 세 번까지 다시 물어보고, 그래도 안 되면 예전과 똑같이 {} 로
        진행한다 — 고치기 전보다 나빠지는 경우가 없다. */
  var fitAsked = false, fitRow = null, fitTries = 0;
  function askFit() {
    if (fitAsked) return;
    fitAsked = true;
    var id = TPL_ID.replace(/^r_/, "");
    var url = SB + "/rest/v1/dc_templates?select=name,fit,width_px,height_px&id=eq." + encodeURIComponent(id);
    var again = function () {
      if (++fitTries < 3) { fitAsked = false; setTimeout(askFit, 800); return; }
      fitRow = {};                       // 세 번 다 실패 — 예전 동작으로 진행한다
      state.why += " fit-failed";        // __dcTplFixDebug() 에 남는다
    };
    try {
      fetch(url, { headers: { apikey: KEY, Authorization: "Bearer " + KEY } })
        .then(function (r) { return r.ok ? r.json() : null; })   // ← 상태를 본다
        .then(function (rows) {
          if (!rows || !Array.isArray(rows)) { again(); return; }  // 400·500·이상한 본문
          fitRow = rows[0] || {};        // 빈 배열 = 정말로 그 행이 없다 (지워진 디자인)
        })
        .catch(again);
    } catch (e) { again(); }
  }
  askFit();

  /* ---- the start popup ------------------------------------------------- */

  // The popup is position:fixed, so offsetParent is null even while it is on
  // screen - visibility has to be measured with getClientRects().
  function popup() {
    var el = document.getElementById("sbdc-start");
    return el && el.getClientRects && el.getClientRects().length ? el : null;
  }

  // Same handle -> card route sb-dc-blank.js uses: the card is labelled with the
  // catalog's own display name, so match on that rather than on any id.
  function pickInPopup(pop, e) {
    var cats = pop.querySelectorAll(".sbdc-cat");
    if (cats.length > e.cat) cats[e.cat].click();
    // 2026-09-15: handle first - Pop-Up 8x8 and 10x8 now share one display name
    var byHandle = pop.querySelector('.sbdc-prod[data-handle="' + e.item.handle + '"]');
    if (byHandle) { byHandle.click(); return true; }
    var label = (e.item.nameKo || e.item.name || "").trim();
    if (!label) return false;
    var cards = pop.querySelectorAll(".sbdc-prod");
    for (var i = 0; i < cards.length; i++) {
      if ((cards[i].textContent || "").trim().indexOf(label) === 0) {
        cards[i].click();
        return true;
      }
    }
    return false;
  }

  /* ---- fitting --------------------------------------------------------- */

  /* 크기 목록 상품(스티커)은 1단계에서 판이 이미 템플릿 크기다 — (b)(c) 의
     «그림 판(피트 단위로 반올림) 에 짓고 다시 맞추기» 는 오히려 타원을 줄인다.
     2026-09-08: refit.js 가 스티커를 품게 되면서 여기서 막는다. */
  function refitReady(a) {
    var handle = a.spec.__dcProd || HANDLE;
    if (hasPresets(catalogEntry(handle))) return false;
    // 반복 벽(스텝앤리핏·백드롭)도 막는다 — 2026-09-08 refit.js 가 이들을 품게 되면서
    // (b) 가 켜져 로고가 두 배로 열렸다(16x8 그림: 6.96in → 13.9in). 열자마자는 예전 그대로.
    if (typeof window.__dcRefitRepeat === "function" && window.__dcRefitRepeat(handle)) return false;
    return typeof window.__dcRefitInScope === "function" &&
           window.__dcRefitInScope(handle) &&
           typeof window.__dcRefit === "function";
  }

  function specCopy(a) {
    var s = {};
    for (var k in a.spec) s[k] = a.spec[k];
    return s;
  }

  function sameShape(w1, h1, w2, h2) {
    return Math.abs(w1 / h1 - w2 / h2) < 0.02;
  }

  /* Route (b): build on the artwork's own board, then fit to the real one.
     Returns null when that path does not apply; the caller falls back to the
     plain build. */
  function buildFitted(a, tpl) {
    var art = boardFromRow(fitRow);
    if (!art || !refitReady(a)) return null;
    var W = a.spec.widthIn, H = a.spec.heightIn;
    if (sameShape(art.w, art.h, W, H)) return null;

    var built = tpl.build(art.w, art.h);
    if (!Array.isArray(built) || !built.length) return null;
    var next = { spec: specCopy(a), front: { layers: built, background: tpl.background } };
    var r = window.__dcRefit({ spec: { widthIn: art.w, heightIn: art.h } }, next);
    var layers = r && r.front && Array.isArray(r.front.layers) ? r.front.layers : null;
    if (layers) { state.art = art; state.why += " art-refit"; }
    return layers;
  }

  /* Route (c): the bundle already drew the template (contain, on the wrong
     board). The layers' combined box is the template as built; treat that box
     as the artwork board and refit it to the real one. Returns true when it
     did something. */
  function refitDrawn(a) {
    var art = boardFromRow(fitRow);
    if (!art || !refitReady(a)) return false;
    var ls = a.doc && a.doc.layers;
    if (!Array.isArray(ls) || !ls.length) return false;

    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    for (var i = 0; i < ls.length; i++) {
      var l = ls[i];
      if (l.visible === false) continue;
      var x = +l.xIn || 0, y = +l.yIn || 0, w = +l.widthIn || 0, h = +l.heightIn || 0;
      if (x < x0) x0 = x;
      if (y < y0) y0 = y;
      if (x + w > x1) x1 = x + w;
      if (y + h > y1) y1 = y + h;
    }
    var bw = x1 - x0, bh = y1 - y0;
    if (!(bw > 0 && bh > 0 && isFinite(bw) && isFinite(bh))) return false;

    // Only the template as built has the artwork's proportions. Anything else
    // on the board (a customer's edits, a refit that already ran) does not,
    // and must be left alone.
    if (Math.abs(bw / bh - art.w / art.h) > 0.1) return false;
    var W = a.spec.widthIn, H = a.spec.heightIn;
    if (sameShape(bw, bh, W, H)) return false;

    var shifted = ls.map(function (l) {
      var o = {};
      for (var k in l) o[k] = l[k];
      o.xIn = (+l.xIn || 0) - x0;
      o.yIn = (+l.yIn || 0) - y0;
      return o;
    });
    var next = { spec: specCopy(a), front: { layers: shifted, background: a.doc.background } };
    var r = window.__dcRefit({ spec: { widthIn: bw, heightIn: bh } }, next);
    var layers = r && r.front && Array.isArray(r.front.layers) ? r.front.layers : null;
    if (!layers) return false;

    a.setDoc({ layers: layers }, false);      // no undo step: not the customer's change
    state.art = { w: bw, h: bh };
    state.why += " drawn-refit";
    return true;
  }

  /* ---- driver ---------------------------------------------------------- */

  function api() {
    var a = window.__dcApi;
    return a && a.spec && a.setSpec && a.loadTemplate ? a : null;
  }

  function onBoard(a) {
    return a.spec.widthIn === state.board.w && a.spec.heightIn === state.board.h;
  }

  var lastCount = -1;
  var ticks = 0;
  var timer = setInterval(function () {
    if (++ticks > 3000) { clearInterval(timer); return; }   // ~6 min, then give up

    var a = api();
    if (!a) return;

    // 1. decide the board
    if (!state.board) {
      var e = catalogEntry(HANDLE);
      /* 2026-09-15: 목록에 없는 묶음 주소(8x8-fabric-pop-up-display-backdrop-with-stand)는
         sb-dc-nostart.js 가 __dcHandle 로 «배너만» 상품을 연다. 그 상품이 정해진 인치
         크기 목록을 가지면 여기서도 같은 상품으로 판을 고른다 — 안 그러면 그림 비율로
         8ft x 8ft(96x96) 판이 되어 팔지 않는 크기로 열렸다. 피트 상품은 예전 그대로. */
      if (!e && window.__dcHandle) {
        var rd = catalogEntry((window.__dcHandle(HANDLE) || {}).dcHandle);
        if (hasPresets(rd)) e = rd;
      }
      if (e) {
        if (hasPresets(e) && !fitRow) return;               // 템플릿 크기를 알아야 고른다
        var b = boardForEntry(e, fitRow);
        if (b) {
          state.board = b;
          state.why = "product:" + HANDLE + (hasPresets(e) ? " preset:" + b.w + "x" + b.h : "");
        }
      }
      if (!state.board) {
        if (!fitRow) return;                                  // wait for the row
        var fromArt = boardFromRow(fitRow);
        if (fromArt) {
          state.board = fromArt;
          state.why = "art:" + fitRow.width_px + "x" + fitRow.height_px;
        } else {
          state.board = boardForFit(fitRow.fit);
          state.why = "fit:" + (fitRow.fit || []).join("|");
        }
      }
    }

    var pop = popup();
    if (pop) state.popupSeen = true;

    // 2. name the right product in the popup
    if (pop && !state.picked && HANDLE) {
      var e2 = catalogEntry(HANDLE);
      if (e2 && pickInPopup(pop, e2)) state.picked = true;
    }

    // 3. nudge the empty canvas onto that board, a few tries only. Fixed inch
    //    products clamp the spec until their product is live, and that is fine -
    //    step 4 is what guarantees the result.
    if (!state.nudged) {
      if (!onBoard(a)) {
        if (state.tries < 8) {
          state.tries++;
          a.setSpec(Object.assign({}, a.spec, {
            widthIn: state.board.w, heightIn: state.board.h
          }));
          return;
        }
      }
      state.nudged = true;
    }

    // 4. build once the popup is gone. Until then the customer can still change
    //    the size in it, and any build before that would just be refit again.
    if (state.popupSeen && pop) return;
    var ns = window.__dcNoStartDebug && window.__dcNoStartDebug();   // 2026-10-01: its Start sets the size - let it go first
    if (ns && !ns.started && ns.gaveUp !== "timeout") return;

    // Pressing Start puts the vinyl default back, so set the board ONCE here.
    // After this one call the size on screen belongs to the customer: if they
    // change it before the template arrives, that is the board it is fitted to.
    if (!state.finalSet) {
      state.finalSet = true;
      if (!onBoard(a)) {
        a.setSpec(Object.assign({}, a.spec, {
          widthIn: state.board.w, heightIn: state.board.h
        }));
        return;
      }
    }

    // The row is one small request and arrives long before the template list
    // does, but wait for it rather than race it.
    if (!fitRow) return;
    if (window.SBDC914?.host.handled(a.doc) || state.applied) { if (!state.applied) { if (window.SBDC914.host.fontsReady && !window.SBDC914.host.fontsReady(a.doc)) return; state.applied = true; state.route = "engine"; } clearInterval(timer); return; }

    // Route (b): the template is in the list - build it ourselves.
    if (typeof window.__dcTemplateList === "function") {
      var list = window.__dcTemplateList([]) || [];
      var tpl = null;
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].id === TPL_ID) { tpl = list[i]; break; }
      }
      if (tpl && typeof tpl.build === "function") {
        try {
          if (tpl.srB) { state.applied = true; state.route = "srB"; clearInterval(timer); return; }   // Step & Repeat template: the bundle already applied it
          var layers = null;
          try { layers = buildFitted(a, tpl); } catch (e3) { layers = null; }
          if (!layers) layers = tpl.build(a.spec.widthIn, a.spec.heightIn);
          a.loadTemplate(layers, tpl.background);
          state.at = { w: a.spec.widthIn, h: a.spec.heightIn };
          state.route = "built";
          if (typeof window.__dcTplApplied === "function") window.__dcTplApplied(tpl);
        } catch (err) {
          state.why += " build-failed";                        // don't loop on a bad template
        }
        state.applied = true;
        clearInterval(timer);
        return;
      }
    }

    // Route (c): not in the list (shape-filtered), but the bundle drew it.
    // Wait for the layer count to hold still for half a second first.
    var n = (a.doc && a.doc.layers && a.doc.layers.length) || 0;
    if (n > 0 && n === lastCount) state.stable++; else state.stable = 0;
    lastCount = n;
    if (n > 0 && state.stable >= 4) {
      try {
        if (refitDrawn(a)) {
          state.at = { w: a.spec.widthIn, h: a.spec.heightIn };
          state.route = "drawn";
        }
      } catch (e4) { state.why += " drawn-failed"; }
      state.applied = true;
      clearInterval(timer);
    }
  }, 120);

  addEventListener("pagehide", function () { clearInterval(timer); });
})();
